import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { onboarding } from './reducer';
import { onboardingScreens } from '../../screens/Onboarding/constants';

const initOnboardingState = {
  currentPhase: '',
  currentScreen: onboardingScreens.SIGNUP,
  screenOptions: {},
  mainSettings: null,
  signupSteps: {
    [onboardingScreens.CONFIRM_EMAIL]: {
      step: 1,
      checked: false,
    },
    [onboardingScreens.ADD_PHONE_NUMBER]: {
      step: 2,
      checked: false,
    },
    [onboardingScreens.CONFIRM_PHONE_NUMBER]: {
      step: 2,
      checked: false,
    },
    [onboardingScreens.ADD_PERSONAL_INFO]: {
      step: 3,
      checked: false,
    },
    [onboardingScreens.ADDITIONAL_PERSONAL_DETAILS]: {
      step: 4,
      checked: false,
    },
    [onboardingScreens.ADD_PHYSICAL_ADDRESS]: {
      step: 5,
      checked: false,
    },
    [onboardingScreens.ADD_MAILING_ADDRESS]: {
      step: 5,
      checked: false,
    },
  },
  registrationStepsOpened: false,
  checkedPhases: {
    account: false,
    phone_number: false,
    personal_information: false,
    additional_personal_details: false,
    physical_address: false,
    mailing_address: false,
  },
};

export const OnboardingContext = createContext(initOnboardingState);

export const OnboardingProvider = ({ children }) => {
  const [state, dispatch] = useReducer(onboarding?.OnboardingReducer, initOnboardingState);

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in onboarding?.actions) {
    boundActions[key] = onboarding.actions[key](dispatch);
  }

  return (
    <OnboardingContext.Provider value={{ state, ...boundActions }}>
      {children}
    </OnboardingContext.Provider>
  );
};

OnboardingProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
